import Member from '@@types/Member';
import MemberLang from '@@types/MemberLang';

import { MemberStatus } from '~/constants';
import MemberMessageHandler from '~/stores/actions/websocketMessageHandlers/Member';
import { channelMembersLangStore } from '~/stores/ChannelMembersLangStore';
import { interTenantMembersStore } from '~/stores/InterTenantMembersStore';
import { userStore } from '~/stores/UserStore';

class InterTenantMemberMessageHandler extends MemberMessageHandler {
  handleLocalStatus = (status: MemberStatus) => {
    interTenantMembersStore.updateStatus({
      id: userStore.id,
      status,
    });
  };

  handleStatusUpdate = ({ memberId, memberStatus }) => {
    if (memberId === userStore.id) return;
    interTenantMembersStore.updateStatus({
      id: memberId,
      status: memberStatus,
    });
  };

  handleUpdate = (member: Member) => {
    interTenantMembersStore.updateMember(member);
  };

  handleUpdateLang = (memberLang: MemberLang) => {
    channelMembersLangStore.update(memberLang);
  };
}

export default InterTenantMemberMessageHandler;
